import React from "react";
import { Container, Row, Col } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';

export default function Footer() {

  return (<footer className='border-top p-2 small'>
    <Container>
      <Row>
        <Col md={3} className="mt-md-0 mt-3 text-center">
          
          <Image  width="50" alt="Tennis Ball Cricket Association"
              height="50" src="/tca-logo.png" rounded />
        </Col>
        <Col xs={6} md={3} className=" mb-md-0 mb-3">
          <h5 className="text-uppercase">Help</h5>
          <ul className="list-unstyled">
            <li><a href="#!">Rules</a></li>
            <li><a href="#!">Forum</a></li>
            <li><a href="#!">Contact Us</a></li>
          </ul>
        </Col>
        <Col xs={6} md={3} className=" mb-md-0 mb-3">
          <h5 className="text-uppercase">Documents</h5>
          <ul className="list-unstyled">
            <li><a href="#!">Score Cards</a></li>
            <li><a href="#!">Permits</a></li>
          </ul>
        </Col>

        <Col xs={6} md={3} className="mb-md-0 mb-3">
          <h5 className="text-uppercase">Community</h5>
          <ul className="list-unstyled">
            <li><a href="#!">Committees</a></li>
            <li> <a target="_blank" mce_href="https://www.facebook.com/groups/tennisballcricket/" href="https://www.facebook.com/groups/tennisballcricket/">
              Facebook Group
            </a></li>
          </ul>
        </Col>
        <Col xs={12} className="text-center">
          &copy; <span className='copyright-span'></span> All Rights Reserved
        
        </Col>

      </Row>
    </Container>
  </footer>);
}